import { useState } from 'react';
import { api } from '../api.js';
import { t } from '../i18n.js';
import { St } from './Status.jsx';

/**
 * De connectiviteitstest (docs/besluiten/connectiviteitstest.md): kan ZERO (ZRO011) een service bereiken? Voor als er
 * geen gegevens binnenkomen. Eén bestemming per keer, een paar poorten; ZERO maakt alleen een TCP-verbinding. Geen scan.
 */
const VOORBEELD = [
  { label: t('HTTPS / API'), ports: '443' },
  { label: t('Syslog (sensor)'), ports: '1470, 6514, 514' },
  { label: 'FMC / FDM', ports: '443' },
  { label: 'ISE MnT', ports: '443' },
  { label: 'Nessus', ports: '8834' },
];
const SOORT = { bereikbaar: 'good', geweigerd: 'warning', 'geen antwoord': 'critical', 'onbekende naam': 'critical' };
const WOORD = { bereikbaar: 'Bereikbaar', geweigerd: 'Geweigerd (poort dicht)', 'geen antwoord': 'Geen antwoord', 'onbekende naam': 'Onbekende naam' };

export default function Connectiviteit() {
  const [host, zetHost] = useState('');
  const [poorten, zetPoorten] = useState('443');
  const [bezig, zetBezig] = useState(false);
  const [uit, zetUit] = useState(null);
  const [fout, zetFout] = useState(null);

  const test = async (e) => {
    e.preventDefault();
    zetFout(null); zetUit(null); zetBezig(true);
    const ports = [...new Set(poorten.split(/[\s,]+/).filter(Boolean).map(Number))].filter((n) => Number.isInteger(n) && n >= 1 && n <= 65535);
    if (!ports.length) { zetFout(t('Vul een of meer poorten in, bijvoorbeeld 443.')); zetBezig(false); return; }
    try { zetUit((await api.connectiviteit({ host: host.trim(), ports })).data); }
    catch (err) { zetFout(t(err.details ? Object.values(err.details)[0] : err.message)); }
    finally { zetBezig(false); }
  };

  return (
    <section className="card">
      <header><h2>{t('Connectiviteit')}</h2></header>
      <p className="muted">{t('Kijkt of ADTS ZERO (de server ZRO011) een service kan bereiken, voor als er geen gegevens binnenkomen. Eén bestemming per keer; ADTS ZERO maakt alleen een TCP-verbinding en kijkt of die lukt. Dit is geen poortscan.')}</p>
      <form className="form" onSubmit={test}>
        {fout && <div className="melder rood">{fout}</div>}
        <div className="two">
          <label className="field"><span>{t('Host of adres')}</span>
            <input className="input mono" value={host} onChange={(e) => zetHost(e.target.value)} placeholder="10.32.200.111" autoComplete="off" /></label>
          <label className="field"><span>{t('Poorten')}</span>
            <input className="input mono" value={poorten} onChange={(e) => zetPoorten(e.target.value)} placeholder="443, 8834" autoComplete="off" />
            <small>{t('Een of meer poorten, met een komma ertussen. Hooguit 20.')}</small></label>
        </div>
        <div className="filters" style={{ margin: '4px 0 10px' }}>
          {VOORBEELD.map((v) => <button key={v.label} type="button" className="chip" onClick={() => zetPoorten(v.ports)}>{v.label}</button>)}
        </div>
        <div className="actions"><button className="btn primary" disabled={bezig || host.trim().length < 2}>{bezig ? t('Bezig…') : t('Testen')}</button></div>
      </form>
      {uit && (
        <table style={{ marginTop: 14 }}>
          <thead><tr><th>{t('Host')}</th><th>{t('Poort')}</th><th>{t('Uitkomst')}</th><th>{t('Tijd')}</th></tr></thead>
          <tbody>{uit.results.map((r) => (
            <tr key={r.port}>
              <td className="mono">{uit.host}</td>
              <td className="mono">{r.port}</td>
              <td><St soort={SOORT[r.status]}>{t(WOORD[r.status] ?? r.status)}</St></td>
              <td className="muted">{r.ms} ms</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </section>
  );
}
